<template>
  <div>
    <el-row>
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;" class="demo-ruleForm">
        <el-col :span="5">
          <el-form-item label="时间搜索类型" prop="timeType">
            <el-select v-model="ruleForm.timeType" placeholder="请选择时间搜索类型">
              <el-option label="消耗日期" :value="1"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" v-if="ruleForm.timeType == 1">
          <el-form-item label="日期时间" prop="tongjiTime">
            <el-date-picker v-model="ruleForm.tongjiTime" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" size="mini" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-else>
          <el-form-item label="修改时间" prop="xiugaiTime">
            <el-date-picker v-model="ruleForm.xiugaiTime" type="datetimerange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" size="mini" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="searchString" style="margin-left: 0px;">
            <el-input v-model.trim="ruleForm.searchString" placeholder="店铺名称、商户ID、广告ID" style="width: 65%;"></el-input>
            <el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
            <el-button type="primary" @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <div class="table-body">
      <div class="table-batch">
        <div>
          <el-button type="danger" @click="delAdjusting" :disabled="ids.length == 0" style="margin-right: 10px;">
            批量删除
          </el-button>
        </div>
        <div>
          <el-button type="primary" @click="dialogVisible = true" style="margin-right: 10px;">
            广告费导入
          </el-button>
          <el-button type="primary" @click="exportVisible = true" style="margin-right: 10px;">
            广告费导出
          </el-button>
        </div>
      </div>
      <div class="table-list">
        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
          <el-table-column prop="sellerId" label="商户ID" align="center"></el-table-column>
          <el-table-column prop="advertiserId" label="广告ID" align="center"></el-table-column>
          <el-table-column prop="statisticsTime" label="消耗日期" align="center"></el-table-column>
          <el-table-column prop="consumptionAmount" label="消耗金额" align="center"></el-table-column>
          <el-table-column prop="currencyCode" label="币种" align="center"></el-table-column>
          <el-table-column prop="rebateRatio" label="返点比例" align="center"
            :formatter="formatRebateRatio"></el-table-column>
          <el-table-column prop="rebateAmount" label="返点金额" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" @click="toAdjusting(scope.row)">手动核准</el-button>
              <el-button type="danger" @click="delAdjusting(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="page">
      <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog title="手动校准" :visible.sync="dialogAdjustingVisible" width="30%" @close="closeAdjusting"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-form :model="adjustingForm" :rules="rulesAdjusting" ref="adjustingForm" label-width="80px"
        class="adjustingForm">
        <el-form-item label="店铺名称" prop="shopName">
          <el-input v-model="adjustingForm.shopName" disabled></el-input>
        </el-form-item>
        <el-form-item label="广告ID" prop="advertiserId">
          <el-input v-model="adjustingForm.advertiserId"></el-input>
        </el-form-item>
        <el-form-item label="统计时间" prop="statisticsTime">
          <el-input v-model="adjustingForm.statisticsTime" disabled=""></el-input>
        </el-form-item>
        <el-form-item label="消耗金额" prop="consumptionAmount">
          <el-input-number v-model="adjustingForm.consumptionAmount" size="mini" :min="0" :controls="true"
            controls-position="both">
          </el-input-number>
          {{ adjustingForm.currencyCode }}
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAdjusting">取消</el-button>
        <el-button type="primary" :loading="btnAdjustingLoading" @click="submitForm('adjustingForm')">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="广告费导入" :visible.sync="dialogVisible" width="30%" @close="handleUploadExcelDialogClose"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess" />
        <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button>
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写，该时区为美东-4时区时间。</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${index + 1}. ${item.fileName}` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <div><span style="color: red">导入异常信息：</span></div>
        <span v-for="(item, index) in errorList" :key="index + 'w'">{{ item }}<br /></span>
      </div>
      <div slot="footer">
        <el-button size="small" @click="handleUploadExcelSubmit" :loading="btnLoading">确定导入
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="广告费导出" :visible.sync="exportVisible" width="30%" @close="handleExportClose"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <el-row type="flex" align="middle">
        <el-date-picker v-model="timeInterval" type="daterange" size="small" value-format="yyyy-MM-dd"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
      </el-row>
      <div slot="footer">
        <el-button size="small" @click="handleExportSubmit" :loading="btnExportLoading">确定导出
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 库存编辑
// 新增产品库存
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '../../../../api/api/api'
export default {
  name: 'FeeImportAds',
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 5,
      size: 20,
      total: 0,
      ruleForm: {
        timeType: 1,
        searchString: '',
        tongjiTime: [],
        xiugaiTime: []
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      btnLoading: false,
      listFile: [],
      returnList: [],
      errorList: '',
      btnAdjustingLoading: false,
      dialogAdjustingVisible: false,
      adjustingForm: {},
      rulesAdjusting: {},
      ids: [],
      timeInterval: [],
      exportVisible: false,
      btnExportLoading: false,
      pickerOptions: {
        // disabledDate(time) {
        // 	return time.getTime() > Date.now()
        // }
      }
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.search()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.returnList = []
      }
    },
    'ruleForm.timeType'(val) {
      if (val == 1) {
        this.ruleForm.xiugaiTime = []
      } else {
        this.ruleForm.tongjiTime = []
      }
    }
  },
  methods: {
    formatRebateRatio(row, column, cellValue) {
      return cellValue ? `${cellValue}%` : '';
    },
    delAdjusting(id = '') {
      this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = []
        if (typeof (id) == 'number' && id) {
          ids = [id]
        } else {
          ids = this.ids
        }
        ajaxPost(Baseurl + 'advertisingFeeController/deleteAdvertisingFee', { ids }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            if (this.tableData.length == 1 && this.currentPage != 1) this.currentPage = this.currentPage - 1
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.data.data
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    toAdjusting(row) {
      this.dialogAdjustingVisible = true
      this.adjustingForm = JSON.parse(JSON.stringify(row))
    },
    closeAdjusting() {
      this.adjustingForm = {}
      this.dialogAdjustingVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnAdjustingLoading = true
          ajaxPost(Baseurl + 'advertisingFeeController/updateAdvertisingFee', { advertiserId: this.adjustingForm.advertiserId, consumptionAmount: this.adjustingForm.consumptionAmount, id: this.adjustingForm.id }).then(() => {
            this.$message.success('校准成功')
            this.closeAdjusting()
            this.search2()
            this.btnAdjustingLoading = false
          })
        }
      })
    },
    handleUploadExcelSubmit() {
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'advertisingFeeController/importAdvertisingFee/' + this.str.rid, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入" + res.data.data.successCount + "条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList
          } else {
            this.dialogVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.search()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear();
      const month = time.getMonth() + 1;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    handleUploadExcelSuccess({ results, header, fileName }) {
      console.log(results);
      let returnList = results.map(item => ({
        shopName: item.店铺名称,
        sellerId: item.商户ID,
        advertiserId: item.广告ID,
        consumptionAmount: item.消耗金额,
        currencyCode: item.币种,
        statisticsTime: this.formatDate(item.消耗日期, '-'),
        rebateRatio: item['返点比例/%']
      }))
      console.log(results);
      console.log(returnList);
      let bool = false
      returnList.map(item => {
        if (item.statisticsTime == "NaN-NaN-NaN") {
          bool = true
        }
      })
      if (bool == true) {
        this.$message.error("时间格式有误，请按照正确格式填写！")
        return
      }
      this.returnList.push(...returnList)
      this.listFile.push({ fileName })
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%B9%BF%E5%91%8A%E8%B4%B9%E6%A8%A1%E6%9D%BF.xls'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%B9%BF%E5%91%8A%E8%B4%B9%E6%A8%A1%E6%9D%BF.xls'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelDialogClose() {
      this.dialogVisible = false
      this.listFile = []
      this.errorList = ''
    },
    search2() {
      this.currentPage = 1
      this.search()
    },
    search() {
      this.loading = true
      if (this.ruleForm.tongjiTime.length) {
        this.$set(this.ruleForm, 'startTime', this.ruleForm.tongjiTime[0])
        this.$set(this.ruleForm, 'endTime', this.ruleForm.tongjiTime[1])
      } else {
        delete this.ruleForm.startTime
        delete this.ruleForm.endTime
      }
      if (this.ruleForm.xiugaiTime.length) {
        this.$set(this.ruleForm, 'startTime1', this.ruleForm.xiugaiTime[0])
        this.$set(this.ruleForm, 'endTime1', this.ruleForm.xiugaiTime[1])
      } else {
        delete this.ruleForm.startTime1
        delete this.ruleForm.endTime1
      }
      // 库存列表
      var obj = {
        page: this.currentPage,
        size: this.size,
        ...this.ruleForm,
        companyId: this.str.company_id
      }
      ajaxPost(
        Baseurl + 'advertisingFeeController/pageInfo',
        obj
      ).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }
        this.loading = false
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        timeType: 1,
        searchString: '',
        tongjiTime: [],
        xiugaiTime: []
      }
      this.search()
    },
    handleSizeChange(val) {
      this.size = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    handleSelectionChange(val) {
      this.ids = val.map(x => x.id)
    },
    handleExportSubmit() {
      if (!this.timeInterval.length) {
        this.$message.error("请先选择时间")
        return
      }
      window.open(`${Baseurl}/advertisingFeeController/exportAdvertisingFee?startTime=${this.timeInterval[0]}&endTime=${this.timeInterval[1]}&companyId=${this.str.company_id}`, 'target');
    },
    handleExportClose() {
      this.timeInterval = []
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.adjustingForm {
  /deep/.el-input {
    width: 70%;

    &.el-input--mini {
      width: auto;
    }
  }
}

.table-body {
  width: 100%;
  border: 1px solid #eee;
  overflow: hidden;
}

.table-batch {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  width: 100%;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}

.textlang {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.file-box {
  padding-top: 20px;
}
</style>
